import ApiEndpoint from "./ApiEndpoint";
import { AxiosResponse } from "axios";
import { MediumFootfallArea } from "../../../model/Geolocation";
import { NumberishId } from "../../../model/type";
import { PatchBodyType } from "../PatchBodyType";

export class Endpoint extends ApiEndpoint {
    public patch = (mediumAvailabilityId: NumberishId, body: PatchBody): Promise<AxiosResponse<MediumFootfallArea>> => {
        return this.connection.patch('/medium-availabilities/' + mediumAvailabilityId, body);
    }
}

export type PatchBody = PatchBodyType<'ACCEPT' | 'REJECT'>
    | PatchBodyType<'TOGGLE_RECOMMENDED', { recommended: boolean }>
    | PatchBodyType<'TOGGLE_POPULAR', { popular: boolean }>;
